// extracted by mini-css-extract-plugin
export var entryListTitle = "entry-list-module--entry-list-title--cf89a";